import { render } from "./DateCalculator.vue?vue&type=template&id=46506f50&scoped=true"
import script from "./DateCalculator.vue?vue&type=script&lang=js"
export * from "./DateCalculator.vue?vue&type=script&lang=js"

import "./DateCalculator.vue?vue&type=style&index=0&id=46506f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46506f50"]])

export default __exports__